import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/13.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Wchodzę do warsztatu"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p29,
            }}
            content={
                <div>
                    <p>
                        Podchodzisz do warsztatu z ceramicznymi kaflami. Gdy wyciągasz rękę, żeby zapukać, drzwi się otwierają, a z izby wypada dwóch wesołych mężczyzn.
                    </p>
                    <ul>
                        <li>Dzień dobry! Może szukacie kogoś do pracy? Kantor… – zanim udaje ci się dokończyć, przerywa ci starszy mężczyzna w kaszkiecie:</li>
                        <li>Do pracy, hę? Do Zagórowa musiałoby się sprowadzić drugie tyle ludzi co teraz, żeby nam starczyło do podziału, a jeszcze każdy z nich musiałby u nas piec kaflowy zamówić… A potem trzymaj kciuki, człowieku, żeby się psuły, bo i z tego jest pieniądz, ale żeby się za bardzo nie popsuły, bo w końcu ty ten piec robiłeś!</li>
                        <li>Dwóch zdunów, cztery ręce do roboty i wystarczy. Trzy osoby dobre, jakbyś partię zakładał. Nie da rady – stwierdza młodszy, zerkając na ciebie niepewnie.</li>
                        <li>Ty, ale może szewc potrzebuje? Tutaj naprzeciwko ma warsztat, zapukaj do niego – dodaje starszy zdun, jak gdyby chciał złagodzić ostry ton swojego pomocnika. – Tobie powodzenia, a my… Robota czeka, jedziemy z tą robotą!</li>
                    </ul>
                    <p>
                        Jednak kantor miał rację. Wychodzisz i kierujesz się do warsztatu szewca.
                    </p>
                </div>
            }
        />

    );
}